import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import ListElement from './ListElement';
import FilterHeaderMobile from './filters/FilterHeaderMobile';
import FilterHeaderWeb from './filters/FilterHeaderWeb';
import PrizePopupWeb from './filters/PrizePopupWeb';
import ExpandedFiltersWeb from './filters/ExpandedFiltersWeb';
import ExpandedFiltersMobile from './filters/ExpandedFiltersMobile';
import ListHeader from './filters/ListHeader';
import FilterError from './filters/FilterError';
import FilterBy from './filters/FilterBy';
import config from '../../config';
import Placeholder from './Placeholder';
import { fill } from 'lodash';
import { AutoSizer } from 'react-virtualized';
import SmartList from './../../SmartList';
import common from "../../common";
import {
    setPlayerRecomendationKey,
    showPlayerRecomMobPopUp
} from './../../actions/FormationActions';
import PlayerRecomendationMobPopList from './filters/PlayerRecomendationMobPopList';
import OutsideNotifier from '../../OutsideNotifier';

class PlayerListing extends PureComponent {
    componentDidUpdate() {
        $(this.scrollToTopElement).off('click').on('click', this.scrollToTop.bind(this));
        if (!this._list) {
            $(this.scrollToTopElement).fadeOut('fast');
        }

        if (this.props.showPlayerRecomMobPopUpFlag) {
            // $($.find(".si-main-container")).addClass("no-ptr-events");
        }
    }



    scrollToTop = () => {
        if (this._list) {
            this._list.scrollToTop();
        }
    };
    onListScroll = (data) => {
        const $this = this;
        if (data.scrollTop > 300) {
            $($this.scrollToTopElement).fadeIn('fast');
        } else {
            $($this.scrollToTopElement).fadeOut('fast');
        }
    };
    _setListRef = ref => {
        this._list = ref;
    };

    render() {
        const { playersInTeam, manageTeamPlayersInTeam, playerCount, playerList, sortBy, teamData } = this.props;
        const MAX_PLAYERS_PER_TEAM = config.MAX_PLAYERS_PER_TEAM;
        const isPlayersLoading = this.props.isPlayersLoading;
        const placeHolderList = fill(new Array(10), null).map((key, index) => {
            return <Placeholder key={ index } />
        });

        function rowRenderer({ key, index, isScrolling, isVisible, style }) {
            const player = playerList[index];
            const playerID = player.Id;
            const isPlayerInTeam = playersInTeam ? playersInTeam.indexOf(playerID) > -1 : false;
            const canRecover = manageTeamPlayersInTeam ? !isPlayerInTeam && manageTeamPlayersInTeam.indexOf(playerID) > -1 : false;
            let isDisabled = (!isPlayerInTeam && (playerCount === MAX_PLAYERS_PER_TEAM));
            let clickButDisabled = false;
            // //check also if budget exceeds
            // if (parseInt(player.Value) > parseInt(budget) && !isPlayerInTeam) {
            //     isDisabled = true;
            // }

            //check if all players filled
            if (common.disablePlayer(teamData, player, teamData.max_playerPerTeam)) {
                clickButDisabled = true;


            }
            const props = { player, isPlayerInTeam, isDisabled, sortBy, canRecover, clickButDisabled };
            return <ListElement key={ key } { ...props } style={ style } />
        }

        const ListView = <AutoSizer>
            { ({ height, width }) => {
                return <SmartList
                    ref={ this._setListRef }
                    onScroll={ this.onListScroll }
                    height={ height }
                    width={ width }
                    rowCount={ playerList.length }
                    rowHeight={ 51 }
                    rowRenderer={ rowRenderer }
                    overscanRowCount={ 6 }
                />
            } }
        </AutoSizer>;
        return <React.Fragment>

            <div className="si-plyr-list-wrap">
                <div className="si-plyr-container si-flexBox">
                    <div className="si-skew-wrap">
                        <div className="si-skew-reverse-wrap">
                            <FilterHeaderMobile toScrollToTop={ this.scrollToTop.bind(this) } />
                            <FilterHeaderWeb toScrollToTop={ this.scrollToTop.bind(this) } /></div>

                    </div>
                    { this.props.showPlayerRecomMobPopUpFlag && common.isMobile() ? <div className="si-modal-wrap si-minus-top" onClick={ () => this.props.showPlayerRecomMobPopUp(false) }> </div> : null }
                    { this.props.showPlayerRecomMobPopUpFlag ? <PlayerRecomendationMobPopList /> : null }
                    <PrizePopupWeb />
                    { common.isMobile() ? null : <ExpandedFiltersWeb /> }
                    <ListHeader />
                    { common.isMobile() && this.props.filterCount ? <FilterBy /> : null }
                    <div className="si-plyr-list-container">
                        <div className="si-full-list-wrap" style={ { height: '100%' } }>
                            <div className="si-list-wrap" style={ { height: '100%' } }>
                                { isPlayersLoading ? placeHolderList : (playerList.length ? ListView :
                                    <FilterError />) }
                            </div>
                        </div>
                    </div>
                    <div className="si-to-top-btn" style={ { display: 'none' } } ref={ (ref) => {
                        this.scrollToTopElement = ref
                    } }>
                        <i className="icon-ucl-arrow_up" />
                    </div>
                </div>
            </div>
            <ExpandedFiltersMobile />
        </React.Fragment >
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        isPlayersLoading: state.formationData.isPlayersLoading,
        playerList: state.formationData.playerList,
        playersInTeam: state.formationData.teamData.playersInTeam,
        playerCount: state.formationData.teamData.playerCount,
        manageTeamPlayersInTeam: state.formationData.manageTeamRawData.playersInTeam,
        sortBy: state.formationData.playerFilters.sortBy,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        playerFilters: state.formationData.playerFilters,
        budget: state.formationData.teamData.budget,
        filterCount: state.formationData.playerFilters.filterCount,
        teamData: state.formationData.teamData,
        playerRecomendationKeys: state.formationData.playerRecomendationKeys,
        playerRecomendedSelectedKey: state.formationData.playerRecomendedSelectedKey,
        showPlayerRecomMobPopUpFlag: state.formationData.showPlayerRecomMobPopUpFlag,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setPlayerRecomendationKey: (obj) => dispatch(setPlayerRecomendationKey(obj)),
        showPlayerRecomMobPopUp: (bool) => dispatch(showPlayerRecomMobPopUp(bool))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayerListing);


// WEBPACK FOOTER //
// ./src/components/onboarding/PlayerListing.js